import { Trans } from '@lingui/react/macro';

import type { HealthCheckFieldAccessErrorType } from '@/api/integration';
import { Text } from '@/components/typography';

import HealthCheckError from './HealthCheckError';

type Props = {
  healthCheck: HealthCheckFieldAccessErrorType;
};

const HealthCheckFieldAccessError = ({ healthCheck }: Props) => {
  return (
    <HealthCheckError
      title={
        <Trans>
          Read access to the following objects and fields are required for this integration, please
          update access and reconnect.
        </Trans>
      }
    >
      {healthCheck.details.source.map((source) => (
        <Text key={source.object} variant="body2">
          <b>{source.object}:</b> {source.fields.join(', ')}
        </Text>
      ))}
    </HealthCheckError>
  );
};

export default HealthCheckFieldAccessError;
